<div class="catalogs-tab d-flex flex-column gap-3 h-100">
  <div class="panel_title">
    {{ 'Aktuell für die Preparation vorgesehener Katalog' | translate }}
  </div>

  <div
    class="upload-zone"
    [class.upload-zone--dragover]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
  >
    <dx-sortable
      class="drop-zone-sortable"
      [data]="activeCatalogItems"
      group="catalogDragGroup"
      itemOrientation="vertical"
      handle=".catalog-row__drag"
      [allowReordering]="false"
      (onAdd)="onDropAddTop($event)"
    >
      <div *ngFor="let catalog of activeCatalogItems" dxSortableItem style="width: 100%;">
        <div
          class="catalog-row catalog-row--active"
          (click)="onCatalogRowClick(catalog.id)"
          [class.catalog-row--selected]="selectedCatalogId === catalog.id"
        >
          <div class="catalog-row__drag">
            <i class="dx-icon-menu"></i>
          </div>
          <div class="catalog-row__main">
            <div class="catalog-row__title">
              {{ catalog.name }}
            </div>
            <div class="catalog-row__subtitle">
              {{ 'Aktiver Katalog' | translate }}
            </div>
          </div>
          <div class="catalog-row__actions">
            <dx-button icon="export" stylingMode="text" type="default" (onClick)="onCatalogJumpClicked(catalog.id)"></dx-button>
            <dx-button icon="overflow" stylingMode="text" type="default" (onClick)="onCatalogOverflowClicked(catalog.id, $event)"></dx-button>
          </div>
        </div>
      </div>
    </dx-sortable>

    <div *ngIf="activeCatalogItems.length === 0" class="drop-zone-placeholder">
      <i class="dx-icon-add" style="font-size: 18px; vertical-align: middle;"></i>
      <span style="margin-left: 6px;">{{ 'Katalog hier ablegen' | translate }}</span>
    </div>

    <input #fileInput type="file" multiple class="d-none" (change)="onFileInputChange($event)" />
  </div>

  <div class="comparison-header">
    <div class="panel_title" style="margin: 0;">
      {{ 'Vergleichskatalog' | translate }}
    </div>
    <dx-button
      text="{{ 'Vergleich starten' | translate }}"
      type="default"
      stylingMode="outlined"
      [disabled]="!canStartComparison || isComparing"
      (onClick)="onStartComparison()"
    >
    </dx-button>
  </div>

  <div
    class="upload-zone upload-zone--compare"
    [class.upload-zone--dragover]="isDragOverCompare"
    (dragover)="onDragOverCompare($event)"
    (dragleave)="onDragLeaveCompare()"
    (drop)="onDropCompare($event)"
  >
    <dx-sortable
      class="drop-zone-sortable"
      [data]="compareCatalogItems"
      group="catalogDragGroup"
      itemOrientation="vertical"
      handle=".catalog-row__drag"
      [allowReordering]="false"
      (onAdd)="onDropAddCompare($event)"
    >
      <div *ngFor="let catalog of compareCatalogItems" dxSortableItem style="width: 100%;">
        <div
          class="catalog-row catalog-row--compare"
          (click)="onCatalogRowClick(catalog.id)"
          [class.catalog-row--selected]="selectedCatalogId === catalog.id"
        >
          <div class="catalog-row__drag">
            <i class="dx-icon-menu"></i>
          </div>
          <div class="catalog-row__main">
            <div class="catalog-row__title">
              {{ catalog.name }}
            </div>
            <div class="catalog-row__subtitle">
              <span class="badge badge--compare">{{ 'Vergleich' | translate }}</span>
            </div>
          </div>
          <div class="catalog-row__actions">
            <dx-button icon="export" stylingMode="text" type="default" (onClick)="onCatalogJumpClicked(catalog.id)"></dx-button>
            <dx-button icon="overflow" stylingMode="text" type="default" (onClick)="onCatalogOverflowClicked(catalog.id, $event)"></dx-button>
          </div>
        </div>
      </div>
    </dx-sortable>

    <div *ngIf="compareCatalogItems.length === 0" class="drop-zone-placeholder">
      <i class="dx-icon-add" style="font-size: 18px; vertical-align: middle;"></i>
      <span style="margin-left: 6px;">{{ 'Katalog hier ablegen' | translate }}</span>
    </div>
  </div>

  <div *ngIf="comparisonCounts" class="comparison-result">
    <span class="badge badge--new">{{ 'Neu' | translate }}: {{ comparisonCounts.neu }}</span>
    <span class="badge badge--changed">{{ 'Geändert' | translate }}: {{ comparisonCounts.geaendert }}</span>
    <span class="badge badge--deleted">{{ 'Gelöscht' | translate }}: {{ comparisonCounts.geloescht }}</span>
  </div>


  <div *ngIf="!hasCatalogs" class="empty-state">
    {{ 'Und hier entsteht Ihr Katalogimportarchiv!' | translate }}
  </div>
</div>

<div class="panel_archiv">
  <div *ngIf="isArchiveLoading" class="mt-2">
    {{ 'Lade Katalogarchiv …' | translate }}
  </div>

  <div *ngIf="!isArchiveLoading && (!archiveCatalogs || archiveCatalogs.length === 0)" class="mt-2">
    <dx-sortable
      [data]="archiveCatalogs"
      group="catalogDragGroup"
      (onAdd)="onDropAddArchive($event)"
    >
      <div style="min-height: 40px;">
        {{ 'Und hier entsteht Ihr Katalogimportarchiv für !' | translate }}
      </div>
    </dx-sortable>
  </div>

  <div *ngIf="!isArchiveLoading && archiveCatalogs?.length" class="mt-2">
    <div class="catalog-list">
      <dx-sortable
        [data]="archiveCatalogs"
        itemOrientation="vertical"
        handle=".catalog-row__drag"
        dragDirection="vertical"
        group="catalogDragGroup"
        (onReorder)="onArchiveReorder($event)"
        (onAdd)="onDropAddArchive($event)"
      >
        <div
          class="catalog-row catalog-row--muted"
          *ngFor="let catalog of archiveCatalogs"
          dxSortableItem
          (click)="onCatalogRowClick(catalog.id)"
          [class.catalog-row--selected]="selectedCatalogId === catalog.id"
        >
          <div class="catalog-row__drag">
            <i class="dx-icon-menu"></i>
          </div>
          <div class="catalog-row__main">
            <div class="catalog-row__title">
              {{ catalog.name }}
            </div>
          </div>
          <div class="catalog-row__actions">
            <dx-button
              icon="overflow"
              stylingMode="text"
              type="default"
              (onClick)="onCatalogOverflowClicked(catalog.id, $event)"
            >
            </dx-button>
          </div>
        </div>
      </dx-sortable>
    </div>
  </div>

    <dx-context-menu
        #catalogContextMenu
        [dataSource]="contextMenuItems"
        showEvent=""
        [width]="200"
        (onItemClick)="itemClick($event)">
        <div *dxTemplate="let e of 'item'">
            <div>
                <span [ngClass]="e.icon"></span>
                <span *ngIf="e.items" class="dx-icon-spinright"></span> {{ e.text }}
            </div>
        </div>
    </dx-context-menu>

    <dx-popup
        class="popup"
        [width]="500"
        [height]="300"
        [showTitle]="true"
        title="Mime importieren"
        [dragEnabled]="true"
        [hideOnOutsideClick]="true"
        [showCloseButton]="true"
        [(visible)]="importMimeVisible"
        (onHiding)="hideImportMime()"
        contentTemplate="popupContent"
    >
        <div *dxTemplate="let data of 'popupContent'">
            <importMime [(isTemplate)]="isTemplate"></importMime>
        </div>
    </dx-popup>


</div>
